import * as types from './mutation_types'

import {createSession, updateSession, deleteSession} from '@/lib/sessions'
import {readCompanyUserData} from '@/lib/company_users'
import {readUserData} from '@/lib/users'
import {completeUserEmailReset} from '@/lib/email_resets'

export default {
  /**
   * Login a user, put session token in store
   */
  loginUser({commit}, user) {
    commit(types.LOADING, true)

    return createSession(user)
      .then(({data}) => {
        commit(types.LOGIN, data)
      })
      .catch((response) => {
        return response
      })
      .finally(() => {
        commit(types.LOADING, false)
      })
  },

  /**
   * Destroy a session
   */
  logoutUser({commit}, session) {
    commit(types.LOADING, true)

    return deleteSession(session)
      .catch((errors) => {
        // TODO: Errors notification
      })
      .finally(() => {
        commit(types.LOGOUT)
        commit(types.LOADING, false)
      })
  },

  /**
   * Refresh a session token
   */
  refreshSessionToken({commit}, session) {
    commit(types.LOADING, true)

    return updateSession(session)
      .then(({response}) => {
        commit(types.LOGIN, response.session)
      })
      .catch((errors) => {
        // TODO: Errors notification
      })
      .finally(() => {
        commit(types.LOADING, false)
      })
  },

  getCurrentUser({commit}, {id}) {
    commit(types.REQUEST_USER)

    return readUserData(id)
      .then(({data}) => {
        const readAt = Date.now()
        const user = data
        const id = user.id

        commit(types.RECEIVE_USER, {id, user, readAt})
      })
      .catch((errors) => {
        // TODO: Errors notification
      })
      .finally(() => {
        commit(types.REQUESTED_USER)
      })
  },

  resetCurrentUserEmail({commit}, {id, token}) {
    commit(types.REQUEST_USER)

    completeUserEmailReset(id, token)
      .then(({data}) => {
        const readAt = Date.now()
        const user = data

        commit(types.RECEIVE_USER, {user, readAt})
      })
      .catch((errors) => {})
      .finally(() => {
        commit(types.REQUESTED_USER)
      })
  },

  getCurrentCompanyUser({commit}, {companyId, id}) {
    commit(types.REQUEST_USER)

    return readCompanyUserData(companyId, id)
      .then(({data}) => {
        const readAt = Date.now()
        const user = data

        commit(types.RECEIVE_USER, {user, readAt})
      })
      .catch((errors) => {
        // TODO: Errors notification
      })
      .finally(() => {
        commit(types.REQUESTED_USER)
      })
  }
}
